(function () {
  function initTogether(section) {
    if (!section || section.dataset.zsTogetherReady === 'true') return;
    section.dataset.zsTogetherReady = 'true';
    var button = section.querySelector('[data-zs-together-add]');
    var status = section.querySelector('[data-zs-together-status]');
    if (!button || !status) return;

    button.addEventListener('click', function () {
      var variants = Array.prototype.slice.call(section.querySelectorAll('[data-zs-together-variant]:checked'));
      if (!variants.length) {
        status.textContent = 'Elegí al menos un producto.';
        status.dataset.error = 'true';
        status.hidden = false;
        return;
      }

      var original = button.textContent;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var payload = { items: variants.map(function (input) { return { id: Number(input.value), quantity: 1 }; }) };
      if (cart && cart.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map(function (item) { return item.id; });
        payload.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(button);
      }

      button.disabled = true;
      button.textContent = 'Agregando…';
      status.hidden = true;
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) throw new Error(response.description || response.message || 'No se pudieron agregar los productos.');
          status.textContent = variants.length === 1 ? 'Producto agregado al carrito.' : 'Productos agregados al carrito.';
          status.dataset.error = 'false';
          status.hidden = false;
          if (cart && cart.renderContents) cart.renderContents(response);
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (error) {
          status.textContent = error.message;
          status.dataset.error = 'true';
          status.hidden = false;
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = original;
        });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-zs-together]').forEach(initTogether);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
